export const colors = {
  primary: '#dc143c',
  primaryDark: '#b71c1c',
  black: '#000000',
  white: '#ffffff',
  
  cyan: '#00c7ff',
  cyanBright: '#1ed2ff',
  darkBg: '#1b2838',
  darkBgSecondary: '#16202d',
  darkBgTertiary: '#0e1419',
  contentText: '#c7d5e0',
  
  primaryTransparent: {
    10: 'rgba(220, 20, 60, 0.1)',
    15: 'rgba(220, 20, 60, 0.15)',
    25: 'rgba(220, 20, 60, 0.25)',
    30: 'rgba(220, 20, 60, 0.3)',
    40: 'rgba(220, 20, 60, 0.4)',
    50: 'rgba(220, 20, 60, 0.5)',
    70: 'rgba(220, 20, 60, 0.7)',
    80: 'rgba(220, 20, 60, 0.8)',
  },
  
  blackTransparent: {
    20: 'rgba(0, 0, 0, 0.2)',
    30: 'rgba(0, 0, 0, 0.3)',
    40: 'rgba(0, 0, 0, 0.4)',
    50: 'rgba(0, 0, 0, 0.5)',
    60: 'rgba(0, 0, 0, 0.6)',
    90: 'rgba(0, 0, 0, 0.9)',
  },
  
  whiteTransparent: {
    30: 'rgba(255, 255, 255, 0.3)',
    50: 'rgba(255, 255, 255, 0.5)',
    70: 'rgba(255, 255, 255, 0.7)',
    80: 'rgba(255, 255, 255, 0.8)',
  },
  
  cyanTransparent: {
    10: 'rgba(0, 199, 255, 0.1)',
    20: 'rgba(0, 199, 255, 0.2)',
    30: 'rgba(0, 199, 255, 0.3)',
    50: 'rgba(0, 199, 255, 0.5)',
  },
  
  gradients: {
    primaryLinear: 'linear-gradient(135deg, #dc143c, #b71c1c)',
    primaryHorizontal: 'linear-gradient(90deg, #dc143c, #b71c1c)',
    borderGradient: 'linear-gradient(90deg, transparent 0%, rgba(220, 20, 60, 0.8) 50%, transparent 100%)',
    shadowFade: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0.5) 50%, transparent 100%)',
    activeBackground: 'linear-gradient(90deg, rgba(220, 20, 60, 0.1), transparent)',
  },
} as const;

export type Colors = typeof colors;